import FormControls from 'component/FormControls';
import Page from 'component/Page';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Form, Row } from 'react-bootstrap';
import { sendPost } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import {
  focusElement,
  getFormData,
  showConfirm,
  showToast,
  loginIdValidate,
} from 'util/utils';
import { RiEyeCloseLine } from 'react-icons/ri';
import { ImEye } from 'react-icons/im';
import Paths from 'util/paths';

// const LOGIN_ID_LIMIT_LENGTH = 16;
// const LOGIN_ID_LIMIT_LENGTH = 50;

// const initialState = {
//   username: '',
//   displayName: '',
//   role: 1,
//   period: '1月',
// };

const PocTrialAdd = ({ data = { id: null, valid: true }, onUpdated }) => {
  //-------------------------------HOOKS-------------------------------------------------------------
	const history = useHistory();
  // const [ showPassword, setShowPassword ] = useState(false);
  // const [userData, setUserData] = useState(initialState);

  //------------------------FUNCTIONS----------------------------------------------------------
  const onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    let formData = getFormData(e.target, {
      rawCol: {
        remainingTime: true,
      },
    });

    if (!formData?.remainingTime) {
      showToast(string.POC_ACCOUNT_TRIAL_REMAINING_TIME_EMPTY_ERROR);
      focusElement('#remainingTime');
      return;
    }
		let second = formData?.remainingTime;
		second = second * 3600;
		second = second + 60;
		let trialData = {
			pocId: data?.pocId,
			remainingTime: second,
		};
		showConfirm({
			body: string.POC_ACCOUNT_TRIAL_ADD_CONFIRM,
			defaultAction: () => {
				sendPost({
						url: Urls.pocaccount.trial,
						body: trialData,
				}).then((res) => {
					showToast(string.POC_ACCOUNT_TRIAL_SUCCESS, 'success');
					// currentUser.pocTrial = 0;
					history.push(Paths.pocaccount.list);
				}).catch((e) => {
					console.log('削除エラー');
				});
			},
		});
    // let userInfo = {
    //   username: loginIdValidate(formData.username),
    //   displayName: formData.displayName,
    //   password: formData.password,
    //   role: 0, //'premium',
    //   status: 0,
    //   autoAssignAllGroups: false,
    // };
    // showConfirm({
    //   body: string.POC_ACCOUNT_CREATE_CONFIRM,
    //   defaultAction: () => {
    //     sendPost({
    //       url: Urls.pocaccount.add,
    //       body: userInfo,
    //     })
    //       .then((res) => {
    //         showToast(string.POC_ACCOUNT_CREATE_SUCCESS, 'success');
    //         onUpdated(res);
    //       })
    //       .catch((e) => { });
    //   },
    // });
  };

  //------------------------------------RETURN---------------------------------------------------------
  return (
    <>
      <Page
        title={string.POC_ACCOUNT_TRIAL}
        body={
          <>
            <Form onSubmit={onSubmit}>
              <FormControls
                data={data}
                controls={[
                  {
                    id: 'remainingTime',
                    title: string.POC_ACCOUNT_TRIAL_REMAINING_TIME,
                    placeholder: '試用時間（時）をご入力ください。※5時間以下の場合は5時間になります。',
                    defaultValue: '5',
                  },
                ]}
                footer={<></>}
              />
              <Row className="form-button-row">
                <Button type="submit">{string.POC_ACCOUNT_TRIAL_ACTIVE}</Button>
              </Row>
            </Form>
          </>
        }
      />
    </>
  );
};

export default PocTrialAdd;
